<template>
  <div
    id="login-screen"
    class="h-screen w-full mx-auto flex items-center justify-center ..."
    :style="loginPage"
  >
    <div class="card flex h-auto w-2/3 inline-block align-middle">
      <div
        class="bg-cover bg-center flex-grow none rounded-l-lg login-picture bg-side"
        :style="cssProps"
      ></div>
      <div
        v-loading="loading"
        class="w-1/2 login bg-gray-400 h-full content-center pt-4 px-8 rounded-r-lg"
      >
        <div class="justify-self-center self-center w-full">
          <div class="flex flex-col justify-center">
            <div class="flex justify-between items-center">
              <div class="py-2">
                <h3 class="text-2xl text-blue-700">Welcome Aboard</h3>
                <h5 class="text-md text-blue-700">Sign In to your Account</h5>
              </div>
              <img src="@/assets/images/logo-corp.png" class="h-12" />
            </div>
            <div class="py-4">
              <el-form
                :model="form"
                :rules="rules"
                ref="loginForm"
                @submit.native.prevent="getLoginKey"
              >
                <el-form-item prop="Username" class="w-full">
                  <el-input
                    placeholder="Username/Email"
                    v-model="form.Username"
                    prefix-icon="el-icon-user"
                    @keyup.enter.native="doLogin"
                  ></el-input>
                </el-form-item>
                <el-form-item prop="Password" class="w-full">
                  <el-input
                    placeholder="Password"
                    v-model="form.Password"
                    prefix-icon="el-icon-lock"
                    @keyup.enter.native="doLogin"
                    show-password
                  ></el-input>
                </el-form-item>
                <!-- <el-button type="primary" round @click="getLoginKey"
                  >Generate Login Key</el-button
                >
                &nbsp;<a href="#" class="text-sm float-right"
                  >Forgot Password?</a
                > -->
              </el-form>
            </div>
            <div class="mt-2 hidden">
              <el-form
                :model="form"
                :rules="rulesSecretCode"
                ref="secretCodeForm"
                @submit.native.prevent="doLogin"
              >
                <el-form-item prop="SecretCode" class="w-full">
                  <el-input
                    placeholder="Login Key"
                    v-model="form.SecretCode"
                    prefix-icon="el-icon-key"
                    show-password
                  ></el-input>
                </el-form-item>
              </el-form>
            </div>
            <div class="flex justify-end">
              <el-button type="primary" class="max-w-lg" @click="doLogin" round
                >Login</el-button
              >
              <!-- <el-button
                class="w-full"
                round
                @click="$router.push({ name: 'Register' })"
                >Register</el-button
              > -->
            </div>
            <div class="flex justify-center items-center text-right">
              <strong class="text-gray-800 text-sm">
                In collaboration with
              </strong>
              <img src="/img/schneider.png" class="ml-2 w-24" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  data() {
    return {
      loading: false,
      cssProps: {
        backgroundImage: `url(${require('@/assets/images/coba.jpg')})`
      },
      loginPage: {
        backgroundImage: `url(${require('@/assets/images/bg-login.png')})`
      },
      form: {
        Username: '',
        Password: '',
        SecretCode: '123'
      },
      rules: {
        Username: [
          { required: true, message: 'Username is required', trigger: 'change' }
        ],
        Password: [
          { required: true, message: 'Password is required', trigger: 'change' }
        ]
      },
      rulesSecretCode: {
        SecretCode: [
          {
            required: true,
            message: 'Login Key is required',
            trigger: 'change'
          }
        ]
      }
    }
  },
  computed: {
    ...mapGetters({
      status: 'authStatus',
      message: 'message'
    })
  },
  methods: {
    async getLoginKey() {
      try {
        this.$refs['loginForm'].validate(async (valid) => {
          if (valid) {
            this.loading = true
            await this.$store.dispatch('getLoginKey', this.form)

            if (this.status == 'error') {
              this.$notify.error({
                message: this.message
              })
            } else {
              this.$notify.success({
                message: this.message
              })
            }
            this.loading = false
          } else {
            this.loading = false
            this.$notify.error({
              message: 'Username & Password required'
            })
          }
        })
      } catch (e) {
        this.loading = false
        this.$notify.error({
          message: this.message
        })
      }
    },
    async doLogin() {
      this.loading = true
      try {
        this.$refs['secretCodeForm'].validate(async (valid) => {
          if (valid) {
            await this.$store.dispatch('getToken', this.form)

            if (this.status == 'error') {
              this.$notify.error({
                message: this.message
              })
            } else {
              this.$message.success('You are successfully logged in')
              this.$router.push('/')
            }
            this.loading = false
          } else {
            this.loading = false
            this.$notify.error({
              message: 'Login Key is required'
            })
          }
        })
      } catch (e) {
        this.loading = false
        this.$notify.error({
          message: this.message
        })
      }
    }
  }
}
</script>

<style>
.login-picture {
  background-size: 100% auto;
}
#login-screen {
  /* background-image: url('assets/images/bg.jpg'); */
  background-repeat: no-repeat;
  background-size: 100% auto;
  background-position: revert;
}
#login-screen #logo {
  height: 62px;
}
.bg-side {
  background-repeat: no-repeat;
  /* background-position: center; */
  /* background: ; */
  background-size: cover;
}
.card-login {
  width: 450px;
}

.el-loading-spinner {
  @apply flex flex-col justify-center items-center;
}

/* #login-screen #left-bg {
  background-image: url('/images/coba.jpg');
  background-size: 100%;
  background-repeat: no-repeat;
  background-color: #2484c5;
} */
#login-screen .el-form .el-input__prefix {
  background: #409eff;
  color: #f8faff;
  font-size: 1.2rem;
  padding: 0 6px;
  left: 0 !important;
  border-radius: 4px 0px 0px 4px;
}

#login-screen .el-form .el-input--prefix .el-input__inner {
  padding-left: 45px;
}

#login-screen .el-form-item.is-error .el-input__inner,
#login-screen .el-form-item.is-error .el-input__inner:focus,
#login-screen .el-form-item.is-error .el-textarea__inner,
#login-screen .el-form-item.is-error .el-textarea__inner:focus,
#login-screen .el-message-box__input input.invalid,
#login-screen .el-message-box__input input.invalid:focus {
  border: 1px solid #dcdfe6;
}
</style>
